import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-full sm:min-w-[560px] rounded-[5px]" }
const _hoisted_2 = { "data-id": "file-upload-accordion-buttons" }
const _hoisted_3 = {
  "data-id": "file-upload-accordion-items",
  class: "bg-white max-h-[315px] pb-3 overflow-y-auto"
}

import { ref, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  /**
   * Expanded/collapsed state
   */
  modelValue: {
    type: Boolean,
    default: null,
  },
  /**
   * Header label
   */
  label: {
    type: String,
    default: '',
  },
  /**
   * The slide effect animation duration length when expanding/collapsing the accordion
   */
  duration: {
    type: Number,
    default: 150,
  },
},
  emits: ['close', 'update:modelValue'],
  setup(__props, { emit }) {

const props = __props





const isExpanded = ref(true)
const accordionExpanded = computed(() => props.modelValue !== null ? props.modelValue : isExpanded.value)

function toggleAccordion () {
  if (props.modelValue !== null) {
    isExpanded.value = !props.modelValue
    emit('update:modelValue', isExpanded.value)
  } else {
    isExpanded.value = !isExpanded.value
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_slide_transition = _resolveComponent("q-slide-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex justify-between items-center pl-5 bg-grey-darkest text-white cursor-pointer",
      onClick: toggleAccordion
    }, [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        _createElementVNode("div", null, _toDisplayString(__props.label), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_q_icon, {
          "data-id": "file-upload-accordion-expand-btn",
          name: "mdi-chevron-down",
          class: _normalizeClass([
            'transition-all',
            _unref(accordionExpanded) ? 'rotate-180' : '',
            'duration-300',
          ]),
          size: "24px"
        }, null, 8, ["class"]),
        _createVNode(_component_q_icon, {
          "data-id": "file-upload-accordion-close-btn",
          class: "py-3 pr-4 pl-1 ml-1",
          name: "mdi-close",
          size: "24px",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["stop"]))
        })
      ])
    ]),
    _createVNode(_component_q_slide_transition, { duration: __props.duration }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("ul", _hoisted_3, [
            _renderSlot(_ctx.$slots, "items")
          ])
        ], 512), [
          [_vShow, _unref(accordionExpanded)]
        ])
      ]),
      _: 3
    }, 8, ["duration"])
  ]))
}
}

})